import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { EMPTY, mergeMap, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { AppInfoSchema } from "../../_offline/models/app-info.schema";
import { STANDALONE } from "../../_offline/standalone-data/standalone-data";
import { OnPremiseSyncProgressDialogComponent } from "../../on-premise-sync-progress-dialog/on-premise-sync-progress-dialog.component";
import { CommonSnackBarService } from "../common-snack-bar.service";
import { AppInfoDbService } from "../database/app-info-db.service";
import { OfflineDataSyncService } from "../offline-data-sync.service";
import { PushOfflineDataSyncService } from "./push-offline-data-sync.service";
import { OnPremiseFirstSyncService } from "./sync-on-premise-data/on-premise-first-sync.service";

@Injectable({
  providedIn: "root"
})
export class SendOfflineDataService {
  constructor(
    private appInfoService: AppInfoDbService,
    private firstSyncService: OnPremiseFirstSyncService,
    private pushOfflineData: PushOfflineDataSyncService,
    private dialog: MatDialog,
    private snackbar: CommonSnackBarService,
    private translateService: TranslateService,
    private offlineDataSyncService: OfflineDataSyncService
  ) {}

  public syncData() {
    return this.appInfoService.get().pipe(
      mergeMap((appInfo) => {
        if (appInfo.switchOnlineBy == null) {
          return EMPTY;
        }
        return this.sendOfflineData(appInfo).pipe(
          catchError(() => {
            this.snackbar.open(this.translateService.instant("inspectionlist.syncError"));
            this.dialog.closeAll();
            return of();
          }),
          mergeMap(() => this.appInfoService.putSwitchOnlineBy(null)),
          mergeMap(() => this.offlineDataSyncService.deleteUploadedOfflineData())
        );
      })
    );
  }

  private openSyncProgressDialog() {
    this.dialog.open(OnPremiseSyncProgressDialogComponent);
  }

  private sendOfflineData(appInfo: AppInfoSchema) {
    if (appInfo.switchOnlineBy == STANDALONE.USER_ID) {
      this.openSyncProgressDialog();
      return this.firstSyncService.syncOfflineData();
    }
    return this.pushOfflineData.syncOfflineData();
  }
}
